import i18next from 'i18next';
import english from './english';
import italian from './italian';

export function translationExists(translation) {
  return i18next.exists(translation);
}

i18next.init({
  interpolation: {
    escapeValue: false
  },
  fallbackLng: 'en',
  resources: {
    en: english,
    it: italian
  }
});

export default i18next;
